var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"myDiv",attrs:{"id":_vm.dynamicId}})
}
var staticRenderFns = []

export { render, staticRenderFns }